// Where each record type opens. A report column with `link: 'order'` (and optional `linkField`
// naming the column that holds the id) becomes openable: double-click the row/cell, or
// middle-click / Ctrl+click, to open that record's page in a new browser tab.
//
// `name` is the vue-router route name of the record's view page; `param` its id param.
// Keep in sync with server/rb/engine/templateSchema.js RECORD_TYPES.
export const RECORD_ROUTES = {
  order: { name: 'order', param: 'id', label: 'Order' },
  customer: { name: 'customer', param: 'id', label: 'Customer' },
  product: { name: 'product', param: 'id', label: 'Product' },
  return: { name: 'Return', param: 'id', label: 'Return' },
  purchaseOrder: { name: 'purchaseOrder', param: 'id', label: 'Purchase order' },
  receivingReport: { name: 'receivingReport', param: 'id', label: 'Receiving report' },
  inventoryTransfer: { name: 'inventoryTransfer', param: 'id', label: 'Inventory transfer' },
  dispatch: { name: 'dispatch', param: 'oid', label: 'Dispatch (by order #)' },
  expense: { name: 'expense', param: 'id', label: 'Expense' },
  user: { name: 'user', param: 'id', label: 'User' },
  location: { name: 'location', param: 'id', label: 'Location' },
  supplier: { name: 'supplier', param: 'id', label: 'Supplier' },
  hirePurchase: { name: 'hirepurchase', param: 'id', label: 'Hire purchase agreement' },
  stocktake: { name: 'StocktakingEvent', param: 'id', label: 'Stocktaking event' },
  brand: { name: 'brand', param: 'id', label: 'Brand' },
  category: { name: 'productcategory', param: 'id', label: 'Category' },
  promotion: { name: 'promotion', param: 'id', label: 'Promotion' },
  serial: { name: 'View Product Serial', param: 'id', label: 'Serial' }
}

/** Absolute URL of a record's page, or null when the type/id is unusable. */
export function recordHref (router, type, id) {
  const def = RECORD_ROUTES[type]
  if (!def || id === null || id === undefined || id === '') return null
  try {
    return router.resolve({ name: def.name, params: { [def.param]: String(id) } }).href
  } catch (e) {
    return null
  }
}

/** Open a record in a new tab. */
export function openRecord (router, type, id) {
  const href = recordHref(router, type, id)
  if (href) window.open(href, '_blank', 'noopener')
  return !!href
}
